import { Swiper } from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

Swiper.use(Navigation);
Swiper.use(Autoplay);
// Swiper.use(Scrollbar);

const navigation = (target) => {
    const swiperClass = {
      nextEl: `.${target}-swiper-controls__next`,
      prevEl: `.${target}-swiper-controls__prev`,
    };

    return swiperClass;
};

$(window).on('load', function () {
    swipers();
});

const swipers = () => {
    productSwiper();
    vloerenSwiper();
    sliderSwiper();
    projectenSwiper();
    vloerenSingleSwiper();
    gallerySwiper();
    postSwiper();
    vacatureSwiper();
}

const vloerenSwiper = () => {
    return new Swiper('.vloeren-swiper', {
        spaceBetween: -1,
        breakpoints: {
            993: {
                slidesPerView: 3,
            },
            767: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        },
        navigation: navigation('vloeren'),
        autoplay: {
            delay: 10000,
        },
    });
}

const sliderSwiper = () => {
    return new Swiper('.slider-swiper', {
        spaceBetween: 0,
        breakpoints: {
            993: {
                slidesPerView: 2,
            },
            767: {
                slidesPerView: 1,
            },
        },
        navigation: navigation('slider'),
    });
}

const projectenSwiper = () => {
    return new Swiper('.projecten-swiper', {
        spaceBetween: 15,
        breakpoints: {
            993: {
                slidesPerView: 2,
            },
            767: {
                slidesPerView: 1,
            },
        },
        navigation: navigation('projecten'),
    });
}

const vloerenSingleSwiper = () => {
    return new Swiper('.vloeren-single-swiper', {
        spaceBetween: 0,
        slidesPerView: 1,
        navigation: navigation('vloeren-single'),
    });
}

const gallerySwiper = () => {
    return new Swiper('.gallery-swiper', {
        spaceBetween: -1,
        slidesPerView: 1,
        breakpoints: {
            993: {
                slidesPerView: 2,
            },
            767: {
                slidesPerView: 1,
            },
        },
        navigation: navigation('gallery'),
    });
}

const postSwiper = () => {
    return new Swiper('.post-swiper', {
        spaceBetween: -1,
        slidesPerView: 1,
        breakpoints: {
            993: {
                slidesPerView: 3,
            },
            767: {
                slidesPerView: 2,
            },
        },
        navigation: navigation('post'),
    });
}

const vacatureSwiper = () => {
    return new Swiper('.vacature-swiper', {
        spaceBetween: 15,
        slidesPerView: 1.1,
        breakpoints: {
            1200: {
                slidesPerView: 2.5,
            },
            993: {
                slidesPerView: 1.5,
            },
            565: {
                slidesPerView: 1.1,
            },
        },
        navigation: navigation('vacature'),
        autoplay: {
            delay: 8000,
        },
    });
}

const productSwiper = () => {
    return new Swiper('.module--product__swiper', {
        spaceBetween: 40,
        slidesPerView: 1.1,
        breakpoints: {
            1200: {
                slidesPerView: 2.5,
            },
            993: {
                slidesPerView: 1.5,
            },
            565: {
                slidesPerView: 1.1,
            },
        },
        navigation: navigation('product'),
    });
}

// $(window).on('resize', function () {
//     if (swiper) {
//         swiper.update();
//     }
// });
